module.exports = __webpack_public_path__ + "img/wf-finishing-position-9.fe887a7b.svg";